/* eslint-disable jsx-a11y/media-has-caption */
import * as React from 'react'
import useRunningAudio from "../lib/state/audio-state";

const AudioBar = () => {
    const {enabled, audio, setEnable} = useRunningAudio();

    React.useEffect(() => {
        if (audio !== null && audio?.fileName !== null) {
            const player = document.getElementById("audio_player");
            player.src = audio?.fileName;

            player.play();
        }
    }, [audio])

    const stopPlay = () => {
        setEnable(false);
    }

    return (
        <div className="audio-bar">
            {enabled ? <div className="flex flex-row py-2 view-width">
                <div>
                    <div className="font-bold">{audio.book}</div>
                    <div>{audio.chapter}</div>
                    
                </div>
                <div className="ps-3 grow">
                    <audio controls id="audio_player" src=''>
                    </audio>
                </div>
                <div>
                    <button onClick={stopPlay}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div> : 
            <div></div>}
        </div>
    )
}

export default AudioBar
